import styled from 'styled-components';
import { BUTTON_SIZES, GhostButton } from 'ui/button';
import { Add16 } from 'ui/icons';
import { Cell } from './Cell';

const StyledButton = styled(GhostButton)`
  width: 100%;
`;

type Props = {
  isShown: boolean;
  onClick: () => void;
};

export const CreateFieldCell = ({ isShown, onClick }: Props) => {
  return (
    <Cell>
      {isShown && (
        <StyledButton data-test="create-field-button" onClick={onClick} size={BUTTON_SIZES.SMALL}>
          <Add16 />
          <span>New field</span>
        </StyledButton>
      )}
    </Cell>
  );
};
